import { reactive, readonly, toRefs } from 'vue'

import { type Toast } from '@/types/Toast'

interface State {
  toasts: Toast[]
}

const state = reactive<State>({
  toasts: []
})

// #region Actions

const addToast = (value: Toast): void => {
  state.toasts.push(value)
}

const checkToastsTimeout = (): void => {
  state.toasts = state.toasts
    .map((toast): Toast => ({ ...toast, second: toast.second - 1 }))
    .filter((toast) => toast.second > 0)
}

// #endregion

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useToast () {
  return {
    ...toRefs(readonly(state)),
    // Actions
    addToast,
    checkToastsTimeout
  }
}
